import { EditAddress } from "./components/myaccount/address";

function EditAddressBook() {
    return (
        <>
            <EditAddress />
        </>
    );
}

export default EditAddressBook;